// src/App.js
import Navbar from "./components/navigation/Navbar";
import Clients from "./sections/Clients";
import Contact from "./sections/Contact";
import Devices from "./sections/Devices";
import FAQ from "./sections/FAQ";
import Features from "./sections/Features";
import Footer from "./sections/Footer";
import HeroHeader from "./sections/HeroHeader";
import Pricing from "./sections/Pricing";
import Software from "./sections/Software";

export default function App() {
  return (
    <div dir="rtl">
      <Navbar />
      <HeroHeader />
      <Features />
      <Software />
      <Devices />
      <Pricing />
      <Clients />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
